import React, { Component, useEffect, useState } from "react";
import { Col, Dropdown, DropdownMenu, DropdownToggle, DropdownItem, Card, CardBody } from "reactstrap";
import { Link } from "react-router-dom";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { PaginationProvider } from "react-bootstrap-table2-paginator";
import { PaginationListStandalone } from "react-bootstrap-table2-paginator";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import { LATEST_TRANSACTION_LOG_COLUMN_DATA } from "../Utility/Constants";
import { connect } from "react-redux";
import { ChargerDiv } from "../Utility/styleComponents";
import { computeConsumption, computeDate, computePaymentStatus, computeTime, computeTotal } from "../Utility/utilsFunctions";
import { chargerSelected } from "../../store/actions";

const LatestTransactions = (props) => {
  const { transactionData, dbFilter, chargerSelected } = props;
  const { dateRange, location } = dbFilter;
  const [menu, setMenu] = useState(false);
  const [transData, setTransData] = useState([]);
  // to update the selected charger data
  const selectCharger = (chargerId) => {
    if (chargerId === null) return;
    chargerSelected(chargerId);
  };

  useEffect(() => {
    let i = 0,
      trans_data = [];
    transactionData.forEach((item, index) => {
      trans_data.push({
        id: ++i,
        conn: item.connectorId,
        orderId: (
          <ChargerDiv
            key={item.chargerId}
            onClick={() => {
              selectCharger(item.chargerId);
              props.history.push("/cms-charger-detail");
            }}
          >
            {item.chargerId}
          </ChargerDiv>
        ),
        date: computeDate(item.startTime) + ", " + computeTime(item.startTime),
        billingName: item.userId,
        total: computeTotal(parseInt(item.meterStart, 10), parseInt(item.meterStop, 10), item?.perUnitRate),
        consumption: computeConsumption(parseInt(item.meterStart, 10), parseInt(item.meterStop, 10)),
        status: computePaymentStatus(parseInt(item.meterStart, 10), parseInt(item.meterStop, 10)),
        transactionId: item.transactionId,
      });
    });
    setTransData(trans_data);
  }, [transactionData, dateRange, location]);

  let data = {
    columns: LATEST_TRANSACTION_LOG_COLUMN_DATA,
    rows: transData,
  };

  const options = {
    hideSizePerPage: false,
    hidePageListOnlyOnePage: false,
    sizePerPageList: [
      {
        text: "5th",
        value: 5,
      },
      {
        text: "10th",
        value: 10,
      },
      {
        text: "All",
        value: transData.length,
      },
    ],
  };
  // const [currentPage, setCurrentPage] = useState(1);

  // // Reset to first page when data changes
  // useEffect(() => {
  //   setCurrentPage(1);
  // }, [transData]);

  // const paginationOptions = {
  //   page: currentPage,
  //   sizePerPage: 5,
  //   totalSize: transData.length,
  //   onPageChange: (page) => setCurrentPage(page),
  //   custom: true,
  // };
  return (
    <React.Fragment>
      <Col>
        <Card>
          <CardBody style={{overflowX:"auto"}}>
            {/* <Dropdown isOpen={menu} toggle={() => setMenu(!menu)} className="float-right">
              <DropdownToggle tag="i" className="arrow-none card-drop">
                <i className="mdi mdi-dots-vertical"></i>
              </DropdownToggle>
              <DropdownMenu right>
                <DropdownItem>Sales Report</DropdownItem>

                <DropdownItem>Export Report</DropdownItem>

                <DropdownItem>Profit</DropdownItem>

                <DropdownItem>Action</DropdownItem>
              </DropdownMenu>
            </Dropdown> */}

            <h4 className="card-title mb-4">Latest Transactions</h4>

            <BootstrapTable keyField="id" data={transData} columns={data.columns} pagination={paginationFactory(options)}  />
            {/* <PaginationProvider pagination={paginationFactory(paginationOptions)}>
              {({ paginationProps, paginationTableProps }) => (
                <div>
                  <BootstrapTable keyField="id" data={transData} columns={data.columns} {...paginationTableProps} />
                  <PaginationListStandalone {...paginationProps} />
                </div>
              )}
            </PaginationProvider> */}
          </CardBody>
        </Card>
      </Col>
    </React.Fragment>
  );
};

const mapDispatchToProps = (dispatch) => ({
  chargerSelected: (payload) => dispatch(chargerSelected(payload)),
});
export default connect(null, mapDispatchToProps)(LatestTransactions);
